<template>
    <div>
        <div class="col-md-12" style="min-height: 150px;">
            <loader v-if="isLoading"/>
            <div v-if="!isLoading">
                <h5>Recording History</h5>
                <v-client-table :data="culturalResourceRecordings" :columns="crrGridSpec.columns" :options="crrGridSpec.options">
                    <template slot="view" slot-scope="props">
                        <div style="text-align: center" v-if="props.row.recordingTypeId !== recordingTypeList.Normalization">
                            <!-- <a  class="fa fa-edit" style="font-size: 18px;" v-on:click="viewRecording(props.row.culturalResourceRecordingId)"></a> -->
                            <router-link :to="{ path: '/CulturalResourceRecording/' + props.row.culturalResourceRecordingId }" tag="a" class="fa fa-edit" style="font-size: 18px;"></router-link>
                        </div>
                    </template>
                    <template slot="shpoCrRecordingNotes" slot-scope="props">
                        <div v-html="props.row.shpoCrRecordingNotes">
                        </div>
                    </template>
                    <template slot="reportGen" slot-scope="props">
                        <!-- <div style="text-align: center;">
                            <a class="fa fa-cloud-download" style="font-size: 18px;" target="_blank" :disabled="reportLoading"
                                v-on:click="genSiteFormReport(props.row.culturalResourceRecordingId)"></a>
                        </div> -->
                        <button :disabled="reportLoading" name="siteFormReport" class="btn btn-primary" v-on:click="genSiteFormReport(props.row.culturalResourceRecordingId)">Generate</button>
                    </template>
                </v-client-table>
                <h5>Scanned Site Form</h5>
                 <table class="table">
                    <thead>
                        <tr>
                            <th style="width:20%">Download</th>
                            <th style="width:40%">File Name</th>
                            <th style="width:40%">Comment</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="form in scannedSiteFormList" :key="form.mediaId">
                            <td>
                                <div style="text-align: center;">
                                    <a class="fa fa-cloud-download" style="font-size: 18px;" target="_blank"
                                    v-on:click="downloadForm(form)"></a>
                                </div>
                            </td>
                            <td>{{form.filename}}</td>
                            <td>{{form.comment}}</td>
                        </tr>
                        <tr v-if="scannedSiteFormList.length === 0">
                            <td colspan="3" style="background-color:#edf0f2; text-align:center">
                                No matching records
                            </td>
                        </tr>
                        
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import culturalResourceRecordingService from '@/services/culturalResourceRecordingService'
import loggingService from '@/services/util/loggingService'
import mediaService from '@/services/mediaService'

import loader from '@/components/Loader'
import { tab, tabs } from 'vue-strap'

export default {
    components: {
        loader,
        tabs,
        tab
    },
    props: {
        loadOnMount: { default: true },
        productionCrrId: { default: null },
        siteTrsList: { default: [] },
        smithNo: { default: '' }
    },
    data: function () {
        return {
            isLoading: true,
            isDebug: false,
            culturalResourceId: this.$route.params.culturalResourceId,
            culturalResource: {},
            culturalResourceRecordings: [],
            crrGridSpec: {
                columns: ['view', 'shpoCrRecordingNotes', 'dbi', 'reportTitle', 'recordingType', 'completeDate', 'reportGen'],
                options: {
                    dateFormat: 'YYYY-MM-DD',
                    perPage: 5,
                    perPageValues: [5, 10, 25],
                    headings: {
                        select: 'Select',
                        dbi: 'DBI',
                        reportTitle: 'Report Title',
                        recordingType: 'Recording Type',
                        shpoCrRecordingNotes: 'Notes',
                        completeDate: 'Complete Date',
                        reportGen: 'Site Form Report'
                    },
                    dateColumns: ['completeDate'],
                    orderBy: {
                        ascending: false,
                        column: 'completeDate'
                    }
                },
                tableData: []
            },
            scannedSiteFormList: [],
            recordingTypeList: culturalResourceRecordingService.RecordingTypeEnum,
            reportLoading: false
        }
    },
    mounted () {
        if (this.loadOnMount) this.loadData()
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'CulturalResourceRecordingHistory', message)
        },
        loadRecordingList () {
            this.log('loading recording list')
            return culturalResourceRecordingService.getRecordingList(this.$http, this.culturalResourceId).then(result => {
                this.culturalResourceRecordings = result.data
                return result
            })
        },
        loadPDFForm () {
            this.log('loading pdfForm media')
            if (this.productionCrrId) {
                return mediaService.list(this.$http, mediaService.mediaType.SiteFormPDF, null, this.productionCrrId).then(result => {
                    this.log('loading pdfForm returned...')
                    this.scannedSiteFormList = result.data
                    return result
                })
            } else {
                return
            }
        },
        loadData () {
            this.log('loading data')
            this.isLoading = true
            var promiseList = [this.loadRecordingList(), this.loadPDFForm()]
            Promise.all(promiseList).then(result => {
                this.log('done loading data')
                this.isLoading = false
            })
        },
        viewRecording (id) {
            this.$router.push('/CulturalResourceRecording/' + id)
        },
        downloadForm (mediaDto) {
            this.log(`DownloadForm - mediaId: ${mediaDto.mediaId} , mediaTypeId: ${mediaDto.mediaTypeId}, parentId: ${mediaDto.parentId}`)
            mediaService.get(this.$http, mediaDto.mediaId, mediaDto.mediaTypeId, mediaDto.mediaSubtypeId, mediaDto.parentId).then(response => {
                mediaService.saveFileToDownload(response, mediaDto.filename)
            })
        },
        genSiteFormReport (crrId) {
            this.reportLoading = true
            if (crrId) {
                culturalResourceRecordingService.siteFormReportGen(this.$http, crrId,
                this.siteTrsList.join(', ')).then(response => {
                    mediaService.saveFileToDownload(response, this.smithNo.replace(' ', '') + '_' + crrId + '_WYCPF.pdf')
                    this.reportLoading = false
                })
            } else {
                this.reportLoading = false
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// CulturalResourceRecordingHistory.vue?194ec34c